import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { HeadsUpSidebar } from "./heads-up-sidebar";
import { ZIndex } from "@/domains/design/constants";

const HEADS_UP_FLOATING_WINDOW_EDGE_OFFSET = 20;
const HEADS_UP_FLOATING_WINDOW_WIDTH = 320;

interface HeadsUpFloatingWindowProps {
  isOpen: boolean;
  topOffset: string;
}

export const HeadsUpFloatingWindow = observer(function HeadsUpFloatingWindow({
  isOpen,
  topOffset,
}: HeadsUpFloatingWindowProps) {
  if (!isOpen) return null;

  return (
    <FloatingWindow $topOffset={topOffset} data-test-id="heads-up-floating-window">
      <HeadsUpSidebar presentation="floating" reserveBottomForChat={false} />
    </FloatingWindow>
  );
});

const FloatingWindow = styled.aside<{
  $topOffset: string;
}>`
  position: absolute;
  top: ${({ $topOffset }) => `calc(${$topOffset} + ${HEADS_UP_FLOATING_WINDOW_EDGE_OFFSET}px)`};
  right: ${HEADS_UP_FLOATING_WINDOW_EDGE_OFFSET}px;
  z-index: ${ZIndex.FloatingBar};
  width: ${HEADS_UP_FLOATING_WINDOW_WIDTH}px;
  max-width: calc(100% - ${HEADS_UP_FLOATING_WINDOW_EDGE_OFFSET * 2}px);
  height: min(
    706px,
    calc(100% - ${({ $topOffset }) => $topOffset} - ${HEADS_UP_FLOATING_WINDOW_EDGE_OFFSET * 2}px)
  );
  max-height: calc(
    100% - ${({ $topOffset }) => $topOffset} - ${HEADS_UP_FLOATING_WINDOW_EDGE_OFFSET * 2}px
  );
  box-sizing: border-box;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface.menu};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.surface};
`;
